<section>
    <div class="container-fluid">
      <div class="row mb-1">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 p-0">
          <div class="container-fluid">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">Home</li>
              <li class="breadcrumb-item">Vendors</li>
              <li class="breadcrumb-item active">{{breadcrumbTitle}}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <section>
    <div class="row mb-1">
      <div class="col-sm-1"></div>
      <div class="col-sm-10 p-0">
        <div class="card Title-bar-blue">
          <div class="devcare-card-header">
            <span class="devcare-sub-header Title-bar-text">{{pageHeader}} </span>

          </div>
          <div class="text-sm text-left">
          </div>
        </div>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </section>
  <section>
    <form [formGroup]="VendorOnboardingForm" novalidate>
      <div class="row mb-1">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 p-0">
          <div class="card vendor-company-profile">
            <!-- <div class="card-header">
              <span class="card-title">Company Profile</span>
            </div> -->
            <div class="card-body">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable">
                  <label class="required">MSA Type<span class="required-field">*</span></label>
                  <p-dropdown (onChange)="getMSATypeOnChange($event)" [options]="msaTypes" placeholder="Select" [disabled]="vendorOnboardingEditId"
                    optionLabel="description" [(ngModel)]="selectedMSATypeId" [ngModelOptions]="{standalone: true}">
                  </p-dropdown>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable">
                  <label class="required">MSA Type<span class="required-field">*</span></label>
                  <p-dropdown (onChange)="getMSATypeOnChange($event)" [options]="msaTypes" placeholder="Select" [disabled]=true
                    optionLabel="description" [(ngModel)]="selectedMSATypeId" [ngModelOptions]="{standalone: true}">
                  </p-dropdown>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable">
                  <label>Vendor Name<span class="required-field">*</span></label>
                  <input class="form-control" id="disabled-input" maxlength="100" formControlName="vendorName"
                    (keyup)="onVendorAvailabilityCheck();preventSqlComments($event)" maxlength="100" type="text"
                    pInputText />
                  <span class="text-danger"
                    *ngIf="(VendorOnboardingFormControl.vendorName.touched) && VendorOnboardingFormControl.vendorName.errors?.required">
                  </span>
                  <span class="text-danger" *ngIf="vendorNameAvail">
                    Vendor Name already exists
                  </span>
                  <span class="text-danger" *ngIf="isSqlComments">
                    Please enter a valid Vendor Name
                  </span>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable">
                  <label>Vendor Name<span class="required-field">*</span></label>
                  <input class="form-control" id="disabled-input" maxlength="100" formControlName="vendorName" maxlength="100" type="text"
                    pInputText disabled/>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="(!isVendorAvailable && !isMSAType1099)">
                  <label>Tax ID<span  class="required-field">*</span></label>
                  <input type="text" class="form-control" formControlName="taxIdNumber" [minLength]="9" 
                    (keyup)="onVendorAvailabilityCheck();onCheckTaxIdNumber()" mask='00-0000000' pInputText>
                  <span class="text-danger"
                    *ngIf="(VendorOnboardingFormControl.taxIdNumber.touched) && VendorOnboardingFormControl.taxIdNumber.errors?.required">
                    Please enter a valid TIN
                  </span>
                  <span class="text-danger"
                    *ngIf="(VendorOnboardingFormControl.taxIdNumber.touched) && VendorOnboardingFormControl.taxIdNumber.errors?.minlength">
                    Please enter a valid TIN
                  </span>
                  <span class="text-danger" *ngIf="taxIdAvail">
                    TIN is already in use
                  </span>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isMSAType1099">
                  <label>Tax ID<span  class="required-field">*</span></label>
                  <input type="text" class="form-control" formControlName="taxIdNumber" [minLength]="9" mask='00-0000000' pInputText disabled>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="(!isVendorAvailable && isMSAType1099)">
                  <label>SSN<span  class="required-field">*</span></label>
                  <input type="text" class="form-control" formControlName="ssnNumber" [minLength]="9" (input)="validateInput($event)"
                  mask='AAA-AA-AAAA'  pInputText>
                  <span class="text-danger"
                    *ngIf="(VendorOnboardingFormControl.ssnNumber.touched) && VendorOnboardingFormControl.ssnNumber.errors?.required">
                    Please enter a valid SSN
                  </span>
                  <span class="text-danger"
                    *ngIf="(VendorOnboardingFormControl.ssnNumber.touched) && VendorOnboardingFormControl.ssnNumber.errors?.minlength">
                    Please enter a valid SSN
                  </span>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && isMSAType1099">
                  <label>SSN<span  class="required-field">*</span></label>
                  <input type="text" class="form-control" formControlName="ssnNumber" [minLength]="9" (input)="validateInput($event)"
                  mask='AAA-AA-AAAA'  pInputText disabled>
                </div>
                <!-- <div class="p-field p-col-12 p-md-4" *ngIf=disableVendorEmail>
                                <label for="vendorEmailId">Email Address<span class="required-field">*</span></label>
                                <input class="form-control" maxlength="100" formControlName="vendorEmailId"
                                  (keyup)="onVendorEmailAvailabilityCheck()" type="email" pInputText disabled>
                              </div> -->
                <!-- <div class="p-field p-col-12 p-md-4">
                  <label for="vendorEmailId"> MSA Agreement Date<span class="required-field">*</span></label>
                  <p-calendar [showIcon]="true" type="date" formControlName="msaAgreementDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                  </p-calendar>
                </div> -->
                <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isMSASelected || isPOSelected || isNCASelected))">
                  <label for="vendorEmailId"> Contract Agreement Date<span class="required-field">*</span></label>
                  <p-calendar [showIcon]="true" type="date" formControlName="contractAgreementDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                  </p-calendar>
               </div> 
               <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isMSASelected && !isPOSelected &&  !isNCASelected">
                <label for="vendorEmailId"> Contract Agreement Date</label>
                <p-calendar [showIcon]="true" type="date" formControlName="contractAgreementDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" [disabled]="true" inputId="navigators">
                </p-calendar>
             </div> 
                <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable && (isMSASelected || isPOSelected))">
                    <label>Vendor Address<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="200" formControlName="addressLine1" type="text" pInputText>
                    <span class="text-danger"
                      *ngIf="(VendorOnboardingFormControl.addressLine1.touched) && VendorOnboardingFormControl.addressLine1.errors?.required">
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isMSASelected && !isPOSelected">
                    <label>Vendor Address<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="200" formControlName="addressLine1" type="text" pInputText disabled>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable && (isNCASelected || isPOSelected))">
                    <label>Applicant Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="150" formControlName="applicantName" type="text" pInputText>
                    <span class="text-danger"
                      *ngIf="(VendorOnboardingFormControl.applicantName.touched) && VendorOnboardingFormControl.applicantName.errors?.required">
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isNCASelected && !isPOSelected">
                    <label>Applicant Name</label>
                    <input class="form-control" maxlength="150" formControlName="applicantName" type="text" pInputText disabled>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isPOSelected))">
                    <label>Client Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="clientName" type="text" pInputText>
                    <span class="text-danger"
                      *ngIf="(VendorOnboardingFormControl.clientName.touched) && VendorOnboardingFormControl.clientName.errors?.required">
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isPOSelected">
                    <label>Client Name</label>
                    <input class="form-control" maxlength="100" formControlName="clientName" type="text" pInputText disabled>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isPOSelected))">
                    <label>Client Address<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="clientAddress" type="text" pInputText>
                    <span class="text-danger"
                      *ngIf="(VendorOnboardingFormControl.clientAddress.touched) && VendorOnboardingFormControl.clientAddress.errors?.required">
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isPOSelected">
                    <label>Client Address</label>
                    <input class="form-control" maxlength="100" formControlName="clientAddress" type="text" pInputText disabled>
                  </div>
                  <!-- <div class="p-field p-col-12 p-md-4">
                    <label for="vendorEmailId"> PO Agreement Date<span class="required-field">*</span></label>
                    <p-calendar [showIcon]="true" type="date" formControlName="poAgreementDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                 </div>   -->
                 <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isPOSelected))">
                        <label for="vendorEmailId"> Contract Start Date<span class="required-field">*</span></label>
                        <p-calendar [showIcon]="true" type="date" formControlName="contractStartDate" [monthNavigator]="true"
                        (onSelect)="onSelectContractStartDate($event)" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                        </p-calendar>
                 </div> 
                 <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isPOSelected">
                  <label for="vendorEmailId"> Contract Start Date</label>
                  <p-calendar [showIcon]="true" type="date" formControlName="contractStartDate" [monthNavigator]="true" [disabled]="true"
                  (onSelect)="onSelectContractStartDate($event)" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                  </p-calendar>
                 </div> 
                 <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isPOSelected))">
                    <label for="vendorEmailId">Est. Contract End Date </label>
                    <p-calendar [showIcon]="true" type="date" formControlName="estContractEndDate" [monthNavigator]="true" 
                    [minDate]="contractEndDate_Start" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>  
                 <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable  && !isPOSelected">
                    <label for="vendorEmailId">Est. Contract End Date </label>
                    <p-calendar [showIcon]="true" type="date" formControlName="estContractEndDate" [monthNavigator]="true" [disabled]="true"
                     [minDate]="contractEndDate_Start" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                  </p-calendar>
                  </div> 
             
                <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isPOSelected))">
                  <label for="vendorPhoneNumber">Rate to Contractor $/hr <span class="required-field">*</span></label>
                  <input id="totalHours" type="text" formControlName="rateToContractor" maxlength="6"
                            (keypress)="numericInputOnly($event)" pInputText>
                  <span class="text-danger" *ngIf="(VendorOnboardingFormControl.rateToContractor.touched) && VendorOnboardingFormControl.rateToContractor.errors?.required">
                    Please enter a valid rate
                  </span>
                  <span class="text-danger" *ngIf="VendorOnboardingFormControl.rateToContractor.touched && VendorOnboardingFormControl.rateToContractor.errors?.pattern">
                    Please enter a valid rate
                  </span>
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isPOSelected">
                  <label for="vendorPhoneNumber">Rate to Contractor $/hr</label>
                  <input  class="form-control" id="totalHours" type="text" formControlName="rateToContractor" maxlength="6"
                            (keypress)="numericInputOnly($event)" pInputText disabled>
                </div>
                <!-- <div class="p-field p-col-12 p-md-4">
                    <label for="vendorEmailId"> NCA Agreement Date<span class="required-field">*</span></label>
                    <p-calendar [showIcon]="true" type="date" formControlName="ncaAgreementDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
             </div> -->
             <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isCOISelected))">
                <label class="required">Insurance Exhibit A<span class="required-field">*</span></label>
                <p-dropdown (onChange)="getinsuranceExhibiOnChange($event)" [options]="insuranceExhibit" placeholder="Select"
                  optionLabel="description" [(ngModel)]="selectedExhibitTypeId" [ngModelOptions]="{standalone: true}">
                </p-dropdown>
              </div>
              <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable && !isCOISelected">
                <label class="required">Insurance Exhibit A<span class="required-field">*</span></label>
                <p-dropdown (onChange)="getinsuranceExhibiOnChange($event)" [options]="insuranceExhibit" placeholder="Select" [disabled]=true
                  optionLabel="description" [(ngModel)]="selectedExhibitTypeId" [ngModelOptions]="{standalone: true}">
                </p-dropdown>
              </div>
              <div class="p-field p-col-12 p-md-8" style="padding-top: 8px;" *ngIf="!isVendorAvailable || (isVendorAvailable &&(isMSASelected))">
                <label for="paymentTerms">Please select the payment terms for vendor<span *ngIf="isSpecial" class="required-field">*</span></label>
                <p-multiSelect class="vendor-onboard"
                [options]="paymentTerms" display="chip"
                (onChange)="getPaymentTermsOnChange($event)" 
                [(ngModel)]="paymentTermsIds" [ngModelOptions]="{standalone: true}"
                defaultLabel={{selectedPaymentTerms}}
                optionLabel="description" [disabled]="!isSpecial"></p-multiSelect>
  
              </div>
              <div class="p-field p-col-12 p-md-8" style="padding-top: 8px;" *ngIf="isVendorAvailable && !isMSASelected">
                <label for="paymentTerms">Please select the payment terms for vendor</label>
                <p-multiSelect class="vendor-onboard"
                [options]="paymentTerms" display="chip"
                (onChange)="getPaymentTermsOnChange($event)" 
                [(ngModel)]="paymentTermsIds" [ngModelOptions]="{standalone: true}"
                defaultLabel={{selectedPaymentTerms}}
                optionLabel="description" [disabled]="true"></p-multiSelect>
  
              </div>
              <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable">
                <label for="paymentTerms">Invoice Terms<span
                        class="required-field">*</span></label>
                <p-dropdown 
                    (onChange)="getInvoiceTermsOnChange($event)"
                   [(ngModel)]="selectedInvoiceTermsId"
                    [ngModelOptions]="{standalone: true}" [options]="invoiceTerms"
                    optionLabel="description">
                </p-dropdown>
            </div>
              <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable">
              <label for="paymentTerms">Invoice Terms<span
                      class="required-field">*</span></label>
              <p-dropdown 
                  (onChange)="getInvoiceTermsOnChange($event)"
                 [(ngModel)]="selectedInvoiceTermsId"
                  [ngModelOptions]="{standalone: true}" [options]="invoiceTerms" [disabled]="true"
                  optionLabel="description">
              </p-dropdown>
              </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="!isVendorAvailable">
                  <label>Please select your vendor category<span class="required-field">*</span></label>
                  <p-dropdown (onChange)="getClientListForRegistrationOnChange($event)"
                    [options]="clientListForRegistration"  [(ngModel)]="selectedClientRegistrationId" [ngModelOptions]="{standalone: true}" optionLabel="description">
                  </p-dropdown>
  
                </div>
                <div class="p-field p-col-12 p-md-4" *ngIf="isVendorAvailable">
                  <label>Please select your vendor category<span class="required-field">*</span></label>
                  <p-dropdown (onChange)="getClientListForRegistrationOnChange($event)" [disabled]="true"
                    [options]="clientListForRegistration"  [(ngModel)]="selectedClientRegistrationId" [ngModelOptions]="{standalone: true}" optionLabel="description">
                  </p-dropdown>
  
                </div>
               
          
  
              </div>
              <div class="row col-lg-12">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                <span class="ml-0 pl-3 text-bold text-sm text-primary" *ngIf="isSpecialC2C">Kindly select Net 30 with 2% fees and Net 45 without fees as the default payment terms for Special C2C</span>
                  <span class="ml-0 pl-3 text-bold text-sm text-primary" *ngIf="isSpecial1099">Kindly select Net 20 with 2% fees, Net 30 with 1% fees and Net 45 without fees as the default payment terms for Special 1099</span>
                </div>
                <div class="col-lg-1"></div>
                </div>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10" *ngIf="isVendorAvailable">
                    <button pButton pRipple type="button" label="Generate & Preview NCA"  iconPos="right" *ngIf="isNCASelected"
                    [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit || isPaymentTermRequired"
                    (click)="generateNCA(VendorOnboardingForm)"  class="p-button-raised p-button-primary float-right m-2"></button>
                    <button pButton pRipple type="button" label="Generate & Preview PO"  iconPos="right" *ngIf="isPOSelected"
                    [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit||isPaymentTermRequired"
                    (click)="generatePO(VendorOnboardingForm)"  class="p-button-raised p-button-primary float-right m-2"></button>
                    <button pButton pRipple type="button" label="Generate & Preview MSA"  iconPos="right"  *ngIf="isMSASelected"
                    [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit || isPaymentTermRequired"
                    (click)="generateMSA(VendorOnboardingForm)"  class="p-button-raised p-button-primary float-right m-2"></button>
                </div>
                <div class="col-md-10" *ngIf="!isVendorAvailable">
                  <button pButton pRipple type="button" label="Generate & Preview NCA"  iconPos="right" 
                  [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit || isPaymentTermRequired"
                  (click)="generateNCA(VendorOnboardingForm)"  class="p-button-raised p-button-primary float-right m-2"></button>
                  <button pButton pRipple type="button" label="Generate & Preview PO"  iconPos="right"
                  [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit||isPaymentTermRequired"
                  (click)="generatePO(VendorOnboardingForm)"  class="p-button-raised p-button-primary float-right m-2"></button>
                  <button pButton pRipple type="button" label="Generate & Preview MSA"  iconPos="right"
                  [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit || isPaymentTermRequired"
                  (click)="generateMSA(VendorOnboardingForm)"  class="p-button-raised p-button-primary float-right m-2"></button>
              </div>
            </div>
            </div>
          </div>
          </div>
          </div>
          </form>
        
  </section>
  <section>
    <p-toast [baseZIndex]="100001" position="bottom-center" key="save"></p-toast>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4"></div>
      <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
        <div class="d-flex p-jc-between">
          <button pButton pRipple type="button" label="Submit" icon="pi pi-check" *ngIf="(!isSpecial && (!isMSASelected  && !isPOSelected && !isNCASelected)) && !vendorOnboardingEditId"
            [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated  || isPaymentTermRequired"
            class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success"
            (click)="OnEmailPopUp(VendorOnboardingForm)"></button>
            <button pButton pRipple type="button" label="Submit for Approval" icon="pi pi-check" *ngIf="(!isSpecial && (isMSASelected || isPOSelected || isNCASelected)) && !vendorOnboardingEditId"
            [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated  || isPaymentTermRequired"
            class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success"
            (click)="OnEmailPopUp(VendorOnboardingForm)"></button>
            <button pButton pRipple type="button" label="Submit for Approval" icon="pi pi-check" *ngIf="isSpecial && !vendorOnboardingEditId"
            [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated || isPaymentTermRequired"
            class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success"
            (click)="OnEmailPopUp(VendorOnboardingForm)"></button>
            <button pButton pRipple type="button" label="Update" icon="pi pi-check" *ngIf="vendorOnboardingEditId"
            [disabled]="!VendorOnboardingForm.valid || !isSaveAvailable || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated || isPaymentTermRequired"
            class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success"
            (click)="update(VendorOnboardingForm)"></button>
          <button *ngIf="tempEmailLinkRefId!=null" pButton pRipple type="button" label="Cancel" icon="pi pi-times"
            class="p-button-outlined p-button-sm p-button-danger float-right m-2 bg-primary"
            (click)="onCancelVendorForm()"></button>
            <button *ngIf="tempEmailLinkRefId===undefined" pButton pRipple type="button" label="Cancel" icon="pi pi-times"
            class="p-button-outlined p-button-sm p-button-danger float-right m-2 bg-primary"
            (click)="backToDashboard()"></button>
        </div>
      </div>
      <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4"></div>
  
    </div>
  </section>
  <p-dialog header="Document Preview" [(visible)]="previewTemplate" [modal]="true"   id="onboarddocpreview"
[draggable]="false" [resizable]="false">
<div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="p-text-normal">
          <br>
          <div class="card pdftop">
          <div class="row">
            <!-- <div class="col-md-6" style="margin-left:35px;"><br>
              <img class="logo"
              [src]="logoOnMSA"
                width="130px">
            </div> -->
          <div class="col-md-6">
            <br>
            <img class="logo" [src]="logoOnLeft" width="160px" style="margin-left: 5px;">
        </div>
        <div class="col-md-6 text-right">
            <br>
            <img class="logo" [src]="logoOnRight" width="270px">
        </div>
          </div>
          <div class="container">  
            <div class="pdfcontent" style="text-align: justify;" [innerHtml]="previewDocumentTemplate"></div>
          </div>
        </div>
        </div>
    </div>
</div>
</p-dialog>
<p-dialog header="Document Preview" [(visible)]="previewSpecialPOTemplate" [modal]="true" id="onboarddocpreview"
  [draggable]="false" [resizable]="false" [closable]="false" style="width: 60% !important;">
<div class="p-fluid p-formgrid p-grid p-col-12 col-sm-12 col-md-12 col-lg-12 p-text-normal container pdftop p-mr-2">
  <p-editor [(ngModel)]="specialPOTemplateForUpdate"   id="podocpreview" [style]="{'height':'700px'}">
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <button type="button" class="ql-strike" aria-label="Strike"></button>
      </span>
    </ng-template>
  </p-editor>
</div>
<ng-template pTemplate="footer">
  <div class="col-md-6"></div>
  <p-button icon="pi pi-times" label="Cancel" (onClick)="closePreviewSpecialPOTemplate()"
    styleClass="p-button-text p-button-danger p-mr-2" [style]="{ height: '30px' }"></p-button>
  <p-button icon="pi pi-check" label="Update" (onClick)="updateSpecialPOTemplate()"
    styleClass="p-button-success p-button-text" [style]="{ height: '30px' }"></p-button>
</ng-template>
</p-dialog>
<p-dialog header="Document Preview" [(visible)]="previewSpecialNCATemplate" [modal]="true" id="onboarddocpreview"
  [draggable]="false" [resizable]="false" [closable]="false" style="width: 60% !important;">
<div class="p-fluid p-formgrid p-grid p-col-12 col-sm-12 col-md-12 col-lg-12 p-text-normal container pdftop p-mr-2">
  <p-editor [(ngModel)]="specialNCATemplateForUpdate"   id="ncadocpreview" [style]="{'height':'700px'}">
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <button type="button" class="ql-strike" aria-label="Strike"></button>
      </span>
    </ng-template>
  </p-editor>
</div>
<ng-template pTemplate="footer">
  <div class="col-md-6"></div>
  <p-button icon="pi pi-times" label="Cancel" (onClick)="closePreviewSpecialNCATemplate()"
    styleClass="p-button-text p-button-danger p-mr-2" [style]="{ height: '30px' }"></p-button>
  <p-button icon="pi pi-check" label="Update" (onClick)="updateSpecialNCATemplate()"
    styleClass="p-button-success p-button-text" [style]="{ height: '30px' }"></p-button>
</ng-template>
</p-dialog>
<p-dialog header="Document Preview" [(visible)]="previewSpecialMSATemplate" [modal]="true" id="onboarddocpreview"
  [draggable]="false" [resizable]="false" [closable]="false" style="width: 60% !important;">
  <div class="p-fluid p-formgrid p-grid p-col-12 col-sm-12 col-md-12 col-lg-12 p-text-normal container pdftop p-mr-2">
    <!-- 
          <div class="col-md-6" style="margin-left:35px;"><br>
            <img class="logo" [src]="logoOnMSA" width="130px">
          </div> -->
    <!-- // <div class="pdfcontent" #previewDocumentTemplate></div> -->
    <p-editor [(ngModel)]="specialMSATemplateForUpdate"   id="msadocpreview" [style]="{'height':'700px'}">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button type="button" class="ql-strike" aria-label="Strike"></button>
        </span>
      </ng-template>
    </p-editor>
  </div>
  <ng-template pTemplate="footer">
    <div class="col-md-6"></div>
    <p-button icon="pi pi-times" label="Cancel" (onClick)="closePreviewSpecialMSATemplate()"
      styleClass="p-button-text p-button-danger p-mr-2" [style]="{ height: '30px' }"></p-button>
    <p-button icon="pi pi-check" label="Update" (onClick)="updateSpecialMSATemplate()"
      styleClass="p-button-success p-button-text" [style]="{ height: '30px' }"></p-button>
  </ng-template>
</p-dialog>
<p-dialog header="Send the Email Link" [(visible)]="isEmailDialog" [modal]="true" [closable]="false" [draggable]="false">
  <!-- <div class=" p-mt-2 p-mb-2">
      <span>Note:</span>
      <ul>
          <li>Image size should be less than 2MB</li>
          <li>Only JPG or PNG files are allowed</li>
      </ul>
  </div> -->
  <div class="p-field p-col-12 p-md-1">
          
  </div>
  <form [formGroup]="emailFormControl">
                
  <div formArrayName="vendorOnboardingEmailAdd" >
  <div class="p-fluid p-formgrid p-grid " *ngFor="let addEmail of emailFormControl.controls.vendorOnboardingEmailAdd['controls']; let i=index;"
  [formGroupName]="i">
      <div class="p-field p-col-12 p-md-9">
          <div *ngIf="(!isVendorAvailable && !isMSAType1099) || isVendorAvailable && !isMSAType1099 && !onlyNCASelected" class="p-text-bold">Vendor Email Id<span class="required-field">*</span></div>
          <div *ngIf="(!isVendorAvailable && isMSAType1099) || isVendorAvailable && isMSAType1099" class="p-text-bold">Email Id<span class="required-field">*</span></div>
          <div class="p-text-normal" *ngIf="(!isVendorAvailable && !isMSAType1099) || isVendorAvailable && !isMSAType1099 && !onlyNCASelected">
              <!-- <input type="text" #description formControlName="emailId" pInputText readonly disabled="true"> -->
              <input type="text" #description formControlName="emailId" pInputText  maxlength="100" >
              <span class="text-danger"
                  *ngIf="(addEmail.controls.emailId.touched) && addEmail.controls.emailId.errors?.required">
                </span>
                <span class="text-danger"
                  *ngIf="addEmail.controls.emailId.touched && addEmail.controls.emailId.errors?.email">
                  Please Enter a Valid Email Address
                </span>
                 <span class="text-danger"
                  *ngIf="addEmail.controls.emailId.touched && addEmail.controls.emailId.errors?.pattern">
                  Please Enter a Valid Email Address
                </span>
                <span class="text-danger" *ngIf="addEmail?.controls?.emailId?.hasError('emailInvalid')">
                  Please Enter a Valid Email Address<br />
                </span>
          </div>
          <div class="p-text-normal" *ngIf="(!isVendorAvailable && isMSAType1099) || isVendorAvailable && isMSAType1099">
            <!-- <input type="text" #description formControlName="emailId" pInputText readonly disabled="true"> -->
            <input type="text" #description formControlName="emailId" pInputText  maxlength="100" >
            <span class="text-danger"
                *ngIf="(addEmail.controls.emailId.touched) && addEmail.controls.emailId.errors?.required">
              </span>
              <span class="text-danger"
                *ngIf="addEmail.controls.emailId.touched && addEmail.controls.emailId.errors?.email">
                Please Enter a Valid Email Address
              </span>
               <span class="text-danger"
                *ngIf="addEmail.controls.emailId.touched && addEmail.controls.emailId.errors?.pattern">
                Please Enter a Valid Email Address
              </span>
              <span class="text-danger" *ngIf="addEmail?.controls?.emailId?.hasError('emailInvalid')">
                Please Enter a Valid Email Address<br />
              </span>
        </div>
      </div>
      <div class="p-field p-col-12 p-md-1" *ngIf="(!isVendorAvailable && !isMSAType1099) || isVendorAvailable && !isMSAType1099 && !onlyNCASelected">
        <div class="p-d-flex p-jc-between">
            <div>
            <button pButton pRipple *ngIf="i!=0"   (click)="removeAdjustmentFields(i)" type="button" icon="pi pi-minus"
                class="p-button-rounded p-button-danger ext-right" style="margin-right: 5px"></button>
            </div>
            <div>
                <button pButton pRipple   (click)="addAdjustmentAmount(i)" type="button" icon="pi pi-plus"
                    class="p-button-rounded float-right"></button>
            </div>
        </div>
    </div>
    <div class="p-field p-col-12 p-md-1" *ngIf="(!isVendorAvailable && isMSAType1099) || isVendorAvailable && isMSAType1099">
      <div class="p-d-flex p-jc-between">
          <div>
          <button pButton pRipple *ngIf="i!=0"   (click)="removeAdjustmentFields(i)" type="button" icon="pi pi-minus"
              class="p-button-rounded p-button-danger ext-right" style="margin-right: 5px"></button>
          </div>
          <div>
              <button pButton pRipple   (click)="addAdjustmentAmount(i)" type="button" icon="pi pi-plus"
                  class="p-button-rounded float-right"></button>
          </div>
      </div>
  </div>
      <div class="p-field p-col-12 p-md-1">
          
      </div>
  </div>
</div>
<div class="p-fluid p-formgrid p-grid " *ngIf="(!isVendorAvailable && !isMSAType1099) || isVendorAvailable && !isMSAType1099 && isNCASelected">
  <div class="p-field p-col-12 p-md-9">
    <div class="p-text-bold">Applicant Email Id<span class="required-field">*</span></div>

    <!-- <div class="p-text-normal">
      <input type="text" #description formControlName="applicantEmailId" pInputText maxlength="100">
      <span class="text-danger"
        *ngIf="(emailFormControl?.controls?.applicantEmailId?.touched) && emailFormControl?.applicantEmailId?.errors?.required">
      </span>
      <span class="text-danger" *ngIf="emailFormControl?.controls?.applicantEmailId?.hasError('emailInvalid')">
        Please Enter a Valid Email Address<br />
      </span>
    </div> -->
    <div class="p-text-normal">
      <input type="text" #description formControlName="applicantEmailId" pInputText  maxlength="100" >
      <span class="text-danger"
          *ngIf="(emailLinkResendFormControl?.applicantEmailId?.touched) && emailLinkResendFormControl?.applicantEmailId?.errors?.required">
          Please enter a email address
      </span>
        <span class="text-danger"
          *ngIf="emailLinkResendFormControl?.applicantEmailId?.touched && emailLinkResendFormControl?.applicantEmailId?.errors?.email">
          Please enter a valid email address
        </span>
         <span class="text-danger"
          *ngIf="emailLinkResendFormControl?.applicantEmailId?.touched && emailLinkResendFormControl?.applicantEmailId?.errors?.pattern">
          Please enter a valid email address
        </span>
        <span class="text-danger" *ngIf="emailLinkResendFormControl?.applicantEmailId?.emailId?.hasError('emailInvalid')">
          Please enter a valid email address<br />
        </span>
  </div>
  </div>
</div>
<div class="p-fluid p-formgrid p-grid ">
  <div class="p-field p-col-12 p-md-9">
    <div class="p-text-bold">Link Validity<span class="required-field">*</span></div>
    <div class="p-text-normal">
      <p-dropdown [options]="linkValidityTypes" placeholder="Select" formControlName="emailLinkValidityHoursId" (onChange)="getEmailLinkValidityOnChange($event)"
      optionLabel="description">
    </p-dropdown>
      <span class="text-danger"
        *ngIf="(emailFormControl?.controls?.emailLinkValidityHoursId?.touched) && emailFormControl?.controls?.emailLinkValidityHoursId?.errors?.required">
      </span>
    </div>
  </div>
</div>
<div class="p-field p-col-12 p-md-2"></div>
<div class="p-field p-col-12 p-md-1">
  <div class="p-text-bold">Comments</div>
</div>
  <div class="card p-m-2 p-p-2">
      <!-- <textarea [rows]="5" [cols]="30" pInputTextarea autoResize="autoResize"></textarea> -->
      <!-- <textarea id="invoiceRejectReason" [(ngModel)]= "invoiceRejectReason" name="invoiceRejectReasonvalidate" required #invoiceRejectReasonvalidate="ngModel" [rows]="5" pInputTextarea style="width: 100%;"></textarea> -->
      <quill-editor [modules]="emailPopUpModel" formControlName="emailBody" placeholder=""
          ></quill-editor>
      <span class="text-danger" *ngIf="emailFormControl.controls.emailBody.hasError('maxlengthError')">
          Only 10000 characters allowed.
      </span>

      <div *ngIf="!isVendorAvailable" class="p-d-flex p-jc-end p-ai-right p-mt-2">
        <button icon="pi pi-times" pButton pRipple type="button"  (click)="onCancelEmailPopUp()" label="Cancel"
              class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-danger" [style]="{ height: '30px' }"></button>
          <button icon="pi pi-check"  *ngIf="!isSpecial" [disabled]="!emailFormControl.valid ||!VendorOnboardingForm.valid || !isSaveAvailable
          || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated"
              (click)="save(VendorOnboardingForm)" pButton type="button" label="Send Link"
              class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success" [style]="{ height: '30px' }" [loading]="loadingSaveButton"></button>
          <button icon="pi pi-check" *ngIf="isSpecial" [disabled]="!emailFormControl.valid ||!VendorOnboardingForm.valid || !isSaveAvailable
          || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated"
            (click)="save(VendorOnboardingForm)" pButton pRipple type="button" label="Submit for Approval"
            class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success" [style]="{ height: '30px' }" [loading]="loadingSaveButton"></button>
      </div>
      <!-- <div *ngIf="isVendorAvailable" class="p-d-flex p-jc-end p-ai-right p-mt-2">
        <p-button icon="pi pi-times"  (click)="onCancelEmailPopUp()" label="Cancel"
              styleClass="p-button-text p-button-danger p-mr-2" [style]="{ height: '30px' }"></p-button>&nbsp;&nbsp;&nbsp;
        <p-button  icon="pi pi-check"  *ngIf="!isSpecial && (!isMSASelected && !isPOSelected && !isNCASelected)" [disabled]="!emailFormControl.valid ||!VendorOnboardingForm.valid || !isSaveAvailable
        || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated"
            (click)="save(VendorOnboardingForm)" pRipple type="button" label="Send Link"
            styleClass="p-button-success p-button-text" [style]="{ height: '30px' }" [loading]="loadingSaveButton"></p-button>
        <p-button icon="pi pi-check" *ngIf="isSpecial || (isMSASelected || isPOSelected || isNCASelected)" [disabled]="!emailFormControl.valid ||!VendorOnboardingForm.valid || !isSaveAvailable
        || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated"
          (click)="save(VendorOnboardingForm)"  type="button" label="Submit for Approval"
          styleClass="p-button-success p-button-text" [style]="{ height: '30px' }" [loading]="loadingSaveButton"></p-button>
    </div> -->

    <div *ngIf="isVendorAvailable" class="p-d-flex p-jc-end p-ai-right p-mt-2">
      <button icon="pi pi-times" pButton pRipple type="button"  (click)="onCancelEmailPopUp()" label="Cancel"
      class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-danger" [style]="{ height: '30px' }"></button>
      <button  icon="pi pi-check"  *ngIf="!isSpecial && (!isMSASelected && !isPOSelected && !isNCASelected)" [disabled]="!emailFormControl.valid ||!VendorOnboardingForm.valid || !isSaveAvailable
      || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated"
          (click)="save(VendorOnboardingForm)" pButton pRipple type="button" label="Send Link"
          class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success" [style]="{ height: '30px' }" [loading]="loadingSaveButton"></button>
      <button icon="pi pi-check" *ngIf="isSpecial || (isMSASelected || isPOSelected || isNCASelected)" [disabled]="!emailFormControl.valid ||!VendorOnboardingForm.valid || !isSaveAvailable
        || vendorNameAvail || isSqlComments || !isMSAType || !isInsuranceExhibit ||!isMSATemplateGenerated ||!isPOTemplateGenerated ||!isNCATemplateGenerated"
        (click)="save(VendorOnboardingForm)" pButton pRipple type="button" label="Submit for Approval"
        class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success" [style]="{ height: '30px' }" [loading]="loadingSaveButton"></button>
  </div>
  </div>
</form>
</p-dialog>
<p-dialog [modal]="true" [style]="{width: '50vw'}" [maximizable]="false" [closable]="false"
[draggable]="false" [resizable]="false" [(visible)]="isMSAEditTemplateWarning">
    <div class="p-fluid">
      <div class="text-center">
        <span style="font-family: Roboto,'system-ui',sans-serif;">{{validationErrorMessage}}</span>
      </div>
      <br>
      <div class="text-center p-mt-2">
        <button pButton pRipple type="button"  (click)="validationErrorPopUpClose()"  [style]="{'width':'100px','height':'30px'}" icon="pi pi-check-circle" label="Ok"
        class="p-button-sm p-button-info"></button>
      </div>
      </div>
</p-dialog>